module.exports = {
    
    methods: {
        
        refreshTooltips() {
            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip()
            })
        },
        
        prettyBytes(value) {
            return window.prettyBytes(parseInt(value))
        },
        
        strlimit(string, limit = 10, completion = '...') {
            if (string.length > limit) {
                return string.substring(0, limit) + completion
            } else {
                return string;
            }
        },
        
        diffForHumans(value) {
            if (value) {
                return moment(value).fromNow();
            }
        },
        
        shortDateTime(value) {
            return moment(value).format("MMMM DD, YYYY - h:mm a");
        },
        
        showDate(value) {
            return moment(value).format("MMMM DD, YYYY");
        },
        
        shortDate(value) {
            return moment(value).format("MMM DD, YYYY");
        },
        
        showTime(value) {
            return moment(value).format("h:mm a");
        },
        
        redirectTo(url, type) {
            if (type == '_blank') {
                window.open(url, type);
                return;
            }
            window.location.href = url;
        },
        
        refreshPage() {
            location.reload();
        },
        
        ucfirst(value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        
        openTab(tab) {
            $(`#${tab}`).tab('show')
        },
        
        snakeCase(string) {
            string = string.replace(/\W+/g, " ").toLowerCase().split(' ').join('_');
            if (string.charAt(string.length - 1) === '_') {
                return string.substring(0, string.length - 1);
            }
            return string;
        },
        
        isAfterNow(date) {
            return moment().isAfter(date)
        }
    },
    
    computed: {
        authId() {
            return App.config.userId;
        }
    }
}